import { Descriptions } from "antd";
import type { ReactNode } from "react";

export interface DetailField<TData> {
  key: keyof TData;
  label: string;
  render?: (data: TData) => ReactNode;
}
interface RecordDetailsProps<TData> {
  data: TData;
  fields: DetailField<TData>[];
}
export function RecordDetails<TData>({
  data,
  fields,
}: RecordDetailsProps<TData>): React.ReactElement {
  return (
    <Descriptions
      bordered
      size="small"
      column={{ xs: 1, sm: 2, lg: 3 }}
      items={fields.map((field) => ({
        key: String(field.key),
        label: field.label,
        children: field.render
          ? field.render(data)
          : String(data[field.key] ?? "-"),
      }))}
    />
  );
}
